var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "bg-premium-dark w-100 h-100 br-8 d-flex align-items-center justify-content-start text-white error-view-z-index",
      class: _vm.background,
    },
    [
      _c("div", { staticClass: "px-5 vue-uploadbox-error-text-container" }, [
        _c(
          "div",
          { staticClass: "font-size-150 font-weight-bold" },
          [
            _vm._t("before-title"),
            _vm._v(" "),
            _c("span", { domProps: { innerHTML: _vm._s(_vm.title) } }),
            _vm._v(" "),
            _vm._t("after-title"),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex flex-column" },
          [
            _vm._t("before-description"),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "description-list" },
              _vm._l(_vm.description, function (text) {
                return _c("li", { domProps: { innerHTML: _vm._s(text) } })
              }),
              0
            ),
            _vm._v(" "),
            _vm._t("after-description"),
          ],
          2
        ),
        _vm._v(" "),
        _vm.showTryPremiumButton
          ? _c(
              "div",
              { staticClass: "d-flex flex-wrap ml-n4 mb-n2" },
              [
                _c("ButtonWithLoadingState", {
                  ref: "buttonPremium",
                  staticClass:
                    "btn btn-warning font-weight-bold ml-4 mb-2 try-premium-button",
                  class: _vm.premiumButtonClass,
                  attrs: {
                    "data-limit-error-box-btn-get-premium": "",
                    "is-state-loading": _vm.isStateLoading,
                    text: _vm.buttonText,
                    icon: "m-l-5 fa fa-arrow-right",
                    "show-icon-after-text": true,
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.$emit("generic-action", $event)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.showSignUpButton
                  ? _c("ButtonWithLoadingState", {
                      staticClass:
                        "btn submit-btn font-weight-bold ml-4 mb-2 sign-up-button",
                      class: _vm.premiumButtonClass,
                      attrs: {
                        "data-limit-error-box-btn-sign-up": "",
                        "is-state-loading": _vm.isStateLoading,
                        text: "Sign Up",
                        icon: "m-l-5 fa fa-arrow-right",
                        "show-icon-after-text": true,
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.$emit("sign-up", $event)
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showReferralButton
                  ? _c("ButtonWithLoadingState", {
                      staticClass:
                        "btn submit-btn font-weight-bold ml-4 mb-2 sign-up-button",
                      class: _vm.premiumButtonClass,
                      attrs: {
                        "data-limit-error-box-btn-referral": "",
                        "is-state-loading": _vm.isStateLoading,
                        text: "Refer a friend",
                        icon: "m-l-5 fa fa-arrow-right",
                        "show-icon-after-text": true,
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.$emit("refer-a-friend", $event)
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.canDismiss && _vm.showStartButton
                  ? _c("ButtonWithLoadingState", {
                      ref: "buttonStartTask",
                      staticClass:
                        "btn btn-lg font-weight-bold ml-4 mb-2 submit-btn text-uppercase try-premium-button",
                      attrs: {
                        "data-limit-error-box-btn-start-task": "",
                        "is-state-loading": _vm.isStateLoading,
                        text: _vm._f("trans")("Start"),
                        icon: "m-l-5 fa fa-arrow-right",
                        "show-icon-after-text": true,
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.$emit("start-task", $event)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("Transition", { attrs: { name: "fade-fast" } }, [
        _vm.canDismiss
          ? _c(
              "span",
              {
                staticClass:
                  "position-absolute cursor-pointer d-block font-size-300 top-0 right-0 pt-3 pr-3 line-height-1ch",
                class: { "opacity-65": _vm.isStateLoading },
                attrs: { "data-limit-error-box-btn-dismiss": "" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.$emit("dismiss", $event)
                  },
                },
              },
              [_vm._v("×")]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }